import { render, staticRenderFns } from "./ButtonGroup.vue?vue&type=template&id=9ff40638&scoped=true&"
import script from "./ButtonGroup.vue?vue&type=script&lang=ts&"
export * from "./ButtonGroup.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonGroup.scss?vue&type=style&index=0&id=9ff40638&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff40638",
  null
  
)

export default component.exports